import type { AxiosResponse } from 'axios';
import apiClient from './apiClient';

export default async function deleteEvent(id: string): Promise<AxiosResponse> {
  return apiClient.delete(`/intern/v2/event/${id}`);
}
